<div class="line">
  <mat-form-field id="label" thin class="inputContainer">
    <input matInput [value]="label" readonly tabindex="-1" />
  </mat-form-field>
  <mat-form-field id="value" thin class="inputContainer">
    <input matInput [value]="value | currency: 'BRL':'symbol'" readonly tabindex="-1" />
  </mat-form-field>
</div>
